export default __webpack_public_path__ + "static/media/XEMP-22.cbe4cff8.jpg";